export const Byerazino = {
  type: "FeatureCollection",
  features: [
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [29.33766660559189, 53.99662540655709],
            [29.331469768969725, 53.99662540655709],
            [29.32611307450628, 53.99662540655709],
            [29.316738860767316, 53.997150210211316],
            [29.311828558033312, 53.997675007249995],
            [29.30736464613028, 54.00003651126758],
            [29.302007952565077, 54.003972053613495],
            [29.297097649831073, 54.00607085756275],
            [29.287277044362895, 54.00580851305506],
            [29.28192035079769, 54.00607085756275],
            [29.275224483841498, 54.00974350967482],
            [29.274778092112058, 54.01367813475707],
            [29.27388531045017, 54.01735011551261],
            [29.270314181107324, 54.02259524005052],
            [29.263618313252664, 54.02679086318835],
            [29.256476055465328, 54.02679086318835],
            [29.247101840828066, 54.0254797767214],
            [29.24174514726309, 54.0241686483937],
            [29.237281235360058, 54.0218085135586],
            [29.230585368403695, 54.02102177218592],
            [29.221211153766433, 54.0218085135586],
            [29.214961677641043, 54.02233299918828],
            [29.21451528681007, 54.02521755404598],
            [29.214961677641043, 54.02888851630263],
            [29.2189791987131, 54.032034797846734],
            [29.221211153766433, 54.03596731434459],
            [29.21853280698383, 54.04068584316349],
            [29.21451528681007, 54.04330701698672],
            [29.21139054919655, 54.04330701698672],
            [29.205141073071104, 54.04776263270503],
            [29.194874075873656, 54.04907301712933],
            [29.181928732792073, 54.04959715890692],
            [29.16675143375869, 54.04854886821289],
            [29.153359698947668, 54.047238467259604],
            [29.140414355866085, 54.04435543991548],
            [29.130147359566877, 54.040947968300884],
            [29.12077314492967, 54.040161588984404],
            [29.11586284219561, 54.040161588984404],
            [29.112738104582093, 54.043044907253886],
            [29.11184532202185, 54.04540383692415],
            [29.111398931190877, 54.05090748548042],
            [29.108274192678834, 54.054576179742924],
            [29.100239152331312, 54.05536228632934],
            [29.092650502814706, 54.054838217275915],
            [29.08282989734647, 54.05300392194465],
            [29.074794856998892, 54.05300392194465],
            [29.06140312218787, 54.052479822613805],
            [29.053814472671263, 54.05143160464536],
            [29.045333040594244, 54.05090748548042],
            [29.035066044295263, 54.05116954615312],
            [29.02613822138727, 54.05274187336926],
            [29.01765678931025, 54.05405210077282],
            [29.008282574673217, 54.05405210077282],
            [29.00618429255627, 54.05399051363355],
            [28.999354751765225, 54.05379005828132],
            [28.987748582074857, 54.051955717198894],
            [28.971678500481232, 54.04854886821289],
            [28.95828676567021, 54.04540383692415],
            [28.94712698770911, 54.043044907253886],
            [28.932842470337846, 54.043044907253886],
            [28.91096930434827, 54.04330701698672],
            [28.880168314552407, 54.043044907253886],
            [28.870794100813498, 54.04173433274008],
            [28.863205451296892, 54.03989945888793],
            [28.856509583442232, 54.03727807069572],
            [28.846688977973997, 54.035443000126804],
            [28.836868372505762, 54.03727807069572],
            [28.834636417452657, 54.03885092355347],
            [28.83329724406127, 54.041210091257824],
            [28.829279722989213, 54.04435543991548],
            [28.821691073472607, 54.0461901170608],
            [28.814995206516244, 54.04566593178015],
            [28.806960166168665, 54.04225856760996],
            [28.80338903682565, 54.038326645704046],
            [28.799817907483032, 54.03282133090357],
            [28.794907604748857, 54.02915071583192],
            [28.788211737792494, 54.027577495967535],
            [28.78419421672038, 54.0273152865185],
            [28.77839113232443, 54.02495533024472],
            [28.77839113232443, 54.02207075720014],
            [28.781515869937778, 54.01839919311931],
            [28.78106947910686, 54.01420272290159],
            [28.77794474059499, 54.01026814795483],
            [28.775712785541828, 54.00502146908178],
            [28.77794474059499, 54.00029889215779],
            [28.78240865249802, 53.997150210211316],
            [28.78687256440128, 53.993476446761065],
            [28.782855043329164, 53.989802359140754],
            [28.776605567203774, 53.98953991209464],
            [28.769463309416437, 53.99032724879942],
            [28.764999397513407, 53.99295159679775],
            [28.756071574605414, 53.993476446761065],
            [28.750268489310997, 53.99242674074651],
            [28.743572622354634, 53.98953991209464],
            [28.73866231962063, 53.984553100253095],
            [28.728841714152395, 53.97720302614289],
            [28.71812832702227, 53.969589082348875],
            [28.709646894945422, 53.96066061763287],
            [28.703397418820032, 53.957771587142986],
            [28.693576813351797, 53.95724628721837],
            [28.684202599612888, 53.95593300871536],
            [28.683222401230466, 53.95542032396787],
            [28.680185078540774, 53.95383167717512],
            [28.680185078540774, 53.94805247005161],
            [28.684202599612888, 53.94384890679481],
            [28.691791249129437, 53.94174696630154],
            [28.697594333525615, 53.941484216491176],
            [28.704736592211248, 53.93938215684517],
            [28.705182983042164, 53.93596608395376],
            [28.70071907203743, 53.93071004140859],
            [28.70295102798906, 53.92781893573709],
            [28.710093285776395, 53.92571618759098],
            [28.71187885089688, 53.92229899638119],
            [28.710093285776395, 53.919670196915774],
            [28.698933506916774, 53.917041231919654],
            [28.691791249129437, 53.916778326527265],
            [28.685095381274778, 53.9180928379937],
            [28.674828384975797, 53.9194073080767],
            [28.66723973545919, 53.91861863109875],
            [28.65920469511144, 53.91493794137227],
            [28.656526347430543, 53.90967924990014],
            [28.657419129990785, 53.90547182068315],
            [28.66902529968138, 53.90310495539899],
            [28.68197064366143, 53.90257896694777],
            [28.687327337226407, 53.90047494744675],
            [28.69089846656925, 53.89758174768167],
            [28.69223763996041, 53.89337309938122],
            [28.69223763996041, 53.88784860567034],
            [28.69402320418277, 53.882849624624725],
            [28.70250463625979, 53.88048147774896],
            [28.70920050411445, 53.88074461162722],
            [28.7150035885104, 53.88153400385522],
            [28.72125306463579, 53.883638977108546],
            [28.729288105881835, 53.88653314221665],
            [28.737769537060387, 53.88653314221665],
            [28.74312623152366, 53.884954531638755],
            [28.744465404915047, 53.8812708749449],
            [28.74312623152366, 53.87837634551721],
            [28.738215928789657, 53.87495527951927],
            [28.729734496712638, 53.87232350028313],
            [28.720360282075546, 53.87048115579836],
            [28.70875411238501, 53.866533002237816],
            [28.701611853699376, 53.86469040268946],
            [28.69446959591204, 53.858372303570945],
            [28.686434554666164, 53.85494960115824],
            [28.681077861101187, 53.849156698020636],
            [28.681077861101187, 53.844416453909446],
            [28.69089846656925, 53.83862209291328],
            [28.702058245428816, 53.832300057652446],
            [28.713664415119183, 53.827294435867316],
            [28.71946750041343, 53.8267674933748],
            [28.727948931592152, 53.827294435867316],
            [28.734198407717543, 53.82913868160051],
            [28.739555102180873, 53.832300057652446],
            [28.745358186576993, 53.832563494665806],
            [28.750714881040437, 53.829665594267055],
            [28.750714881040437, 53.82492314324918],
            [28.747143751697422, 53.820707180160355],
            [28.74000149301179, 53.81728139771491],
            [28.7337520168864, 53.81543662999246],
            [28.727948931592152, 53.81385533573268],
            [28.722592238027005, 53.81148328194678],
            [28.720360282075546, 53.80779315432267],
            [28.72437780314766, 53.804102701853026],
            [28.729288105881835, 53.80436631671523],
            [28.7337520168864, 53.80621157168929],
            [28.73866231962063, 53.807529561537365],
            [28.744019013185778, 53.807529561537365],
            [28.74937570764905, 53.80542075799775],
            [28.75517879204517, 53.80093919847019],
            [28.75964270394826, 53.79645715992473],
            [28.764553006682263, 53.79434779946456],
            [28.767231353464865, 53.7914472556763],
            [28.764106614952993, 53.78722792526804],
            [28.756071574605414, 53.783008169944196],
            [28.7529468360936, 53.779315536025194],
            [28.754286010383055, 53.77483118658978],
            [28.760535486508502, 53.771665475096825],
            [28.76589218007365, 53.769818699446375],
            [28.76812413602528, 53.764805613739156],
            [28.76990970024741, 53.758736340923065],
            [28.77214165619904, 53.75319406500131],
            [28.77392722042123, 53.74553924283157],
            [28.771248873638626, 53.738147056883236],
            [28.758749921388016, 53.73233799845303],
            [28.7529468360936, 53.72916908293797],
            [28.746697359968152, 53.724943490852866],
            [28.74491179574602, 53.720717473560285],
            [28.74000149301179, 53.719925048104415],
            [28.732859234326156, 53.718604305654424],
            [28.734198407717543, 53.71490600646359],
            [28.744019013185778, 53.71199997179684],
            [28.751607662702384, 53.70935794769832],
            [28.75964270394826, 53.70697998446951],
            [28.769016917687168, 53.701959398165116],
            [28.773480829590255, 53.69614533994502],
            [28.774820002981414, 53.686365338659755],
            [28.774820002981414, 53.68134229358333],
            [28.7761591763728, 53.676583065926536],
            [28.781515869937778, 53.67182330103748],
            [28.785979781841036, 53.664682644801246],
            [28.78687256440128, 53.65674716361815],
            [28.79312204052667, 53.65066228216091],
            [28.80562099277728, 53.641400995686695],
            [28.819905509250248, 53.63504922328298],
            [28.832404461501028, 53.626578706108205],
            [28.835529199114603, 53.62048947147383],
            [28.83508280828363, 53.61545857130983],
            [28.830618896380372, 53.61069190209918],
            [28.831511678940785, 53.60460037546636],
            [28.835529199114603, 53.60115695026627],
            [28.846242587143024, 53.595858824408765],
            [28.851599280708, 53.59294457187082],
            [28.855170410051016, 53.585525567528066],
            [28.856955975171502, 53.577310150538835],
            [28.858036397539422, 53.57217786506459],
            [28.87141340380566, 53.57188366479937],
            [28.87588529257232, 53.57082146383965],
            [28.890195339143702, 53.562322892987254],
            [28.900033496948367, 53.55222862355214],
            [28.902716629668816, 53.546383470920546],
            [28.912554787473482, 53.53734846615896],
            [28.918815432286408, 53.53096965402642],
            [28.928653590091244, 53.52565324430185],
            [28.94028050304297, 53.52565324430185],
            [28.951819297779537, 53.52723614876379],
            [28.95190741599447, 53.52724823691665],
            [28.96353432804682, 53.532032856830995],
            [28.956379305660505, 53.544257760487255],
            [28.956379305660505, 53.55222862355214],
            [28.952801793568085, 53.5633853079857],
            [28.954590549614295, 53.57029035301747],
            [28.968006217712855, 53.57188366479937],
            [28.97784437461837, 53.57241475583646],
            [28.993048799662517, 53.58038031469982],
            [29.007358846233842, 53.57719427119878],
            [29.023457648851604, 53.57453905163601],
            [29.051183363521545, 53.57613220333866],
            [29.06638778856569, 53.575070108498835],
            [29.075331567897592, 53.57613220333866],
            [29.087852858422707, 53.58250421030124],
            [29.07980345666425, 53.59365291055349],
            [29.07801470061804, 53.59789926104213],
            [29.07622594547115, 53.61063575213842],
            [29.073542811851325, 53.61806359825647],
            [29.07980345666425, 53.62124656068028],
            [29.090535992042533, 53.62602055510456],
            [29.096796637754778, 53.63768804456765],
            [29.101268527420643, 53.646701622082276],
            [29.093219125662188, 53.65942339397458],
            [29.097691015328223, 53.66737255190185],
            [29.108423549807128, 53.6684323264908],
            [29.122733596378453, 53.66737255190185],
            [29.143304289561456, 53.66472299896725],
            [29.158508713706226, 53.66313318734677],
            [29.17103000423134, 53.65571327324909],
            [29.183551294756512, 53.649352307263314],
            [29.211277010325944, 53.64617146454145],
            [29.228270190516923, 53.65359305857288],
            [29.23900272589526, 53.65995338424136],
            [29.249735260373996, 53.66154331547176],
            [29.260467795752277, 53.66419306895506],
            [29.2658340629917, 53.67161149017812],
            [29.277460975943427, 53.675320210659265],
            [29.303397935466478, 53.67585000127667],
            [29.31413046994527, 53.681677257399656],
            [29.31949673808407, 53.6933293531672],
            [29.32665176136976, 53.69968368305558],
            [29.332912407082006, 53.707095855789305],
            [29.328440516516764, 53.7155653110903],
            [29.32665176136976, 53.72456223855664],
            [29.340961807941085, 53.72985365072549],
            [29.351694342420046, 53.72456223855664],
            [29.35884936570568, 53.71768240781705],
            [29.36958190108396, 53.70868400816056],
            [29.382103191609133, 53.70868400816056],
            [29.386341050196222, 53.711610288458076],
            [29.387469458848557, 53.71238946500199],
            [29.387469458848557, 53.72456223855664],
            [29.389258214894824, 53.72985365072549],
            [29.403568261466148, 53.73355724237291],
            [29.418772686510465, 53.73778951937095],
            [29.42771646494299, 53.745723889745875],
            [29.416089551991263, 53.750483792693046],
            [29.396413238180457, 53.75207030739881],
            [29.387469458848557, 53.76000198250557],
            [29.399990750272934, 53.7679321593418],
            [29.418772686510465, 53.76846078443771],
            [29.450075913272826, 53.76634624358434],
            [29.472435360703457, 53.768989402339116],
            [29.491217296940818, 53.77321811172658],
            [29.501949832318928, 53.78325958825951],
            [29.49390043145985, 53.790657032795934],
            [29.476012872795877, 53.79435526628265],
            [29.458125314132076, 53.798581418897356],
            [29.446498401180406, 53.802807146132864],
            [29.438448999421894, 53.80703244798917],
            [29.42324457617633, 53.808616826805235],
            [29.391046970941034, 53.810729237164594],
            [29.365110011417926, 53.812841542303374],
            [29.370476278657407, 53.817065832422315],
            [29.380314435562923, 53.82287353638469],
            [29.387469458848557, 53.825513135622714],
            [29.385680703701553, 53.83184749606511],
            [29.377631302842474, 53.839764098534374],
            [29.394624482134248, 53.844513341817446],
            [29.409828906279017, 53.845568656668206],
            [29.41787830803753, 53.85401021320075],
            [29.408040151132184, 53.860867724565935],
            [29.391046970941034, 53.86772411177839],
            [29.391046970941034, 53.87247018315253],
            [29.40177950541994, 53.87721571673194],
            [29.40177950541994, 53.88934074348066],
            [29.40177950541994, 53.89671947312536],
            [29.39373010456086, 53.90567760743579],
            [29.383891947655343, 53.916214130178105],
            [29.38299756918252, 53.92464143515423],
            [29.38299756918252, 53.93201393069842],
            [29.382103191609133, 53.94043804577933],
            [29.374948168323442, 53.94570225435558],
            [29.368687522611197, 53.95307103030393],
            [29.373159412277232, 53.96359559386167],
            [29.379420057989478, 53.96570018731387],
            [29.374053790749826, 53.97727355553036],
            [29.36958190108396, 53.986214411166316],
            [29.353483098466256, 53.98779200999337],
            [29.33766660559189, 53.99662540655709],
          ],
        ],
      },
      properties: {
        shapeName: "Byerazino",
        shapeISO: "",
        shapeID: "67162791B55727051267470",
        shapeGroup: "BLR",
        shapeType: "ADM2",
      },
    },
  ],
};
